import React, { useState } from "react";
import RadarChart from "./RadarChart";
import { Typography } from "@mui/material";
import { Chart as ChartJS } from "chart.js/auto";

const codePapikostik = [
  "G",
  "A",
  "L",
  "P",
  "I",
  "T",
  "V",
  "X",
  "S",
  "B",
  "O",
  "R",
  "D",
  "C",
  "Z",
  "E",
  "K",
  "F",
  "W",
  "N",
];

function ChartPapikostik(props) {
  const { dataCandidateByID } = props;

  const [dataPapikostik, setDataPapikostik] = useState({
    labels: dataCandidateByID?.Papikostik
      ? codePapikostik.map((code) => code)
      : null,

    datasets: [
      {
        label: "Score",
        data: dataCandidateByID?.Papikostik
          ? codePapikostik.map((data) => {
              const found = dataCandidateByID.Papikostik.find((papi) => {
                if (data === papi.code) {
                  return papi;
                }
              });
              return found.score;
            })
          : "",
        backgroundColor: ["rgba(75,192,192,1)"],
      },
    ],
  });

  return (
    <>
      {dataCandidateByID.Papikostik ? (
        <div>
          <RadarChart chartData={dataPapikostik} />
        </div>
      ) : (
        <div className="form-row mt-2">
          <div className="col-md-6">
            <Typography>Papikostik Result Not Found</Typography>
          </div>
        </div>
      )}
    </>
  );
}

export default ChartPapikostik;
